// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V0VhC","footer":"styles_footer__r_dpi","passCodeTooltip":"styles_passCodeTooltip__1EM1q"};